import React, { useMemo } from 'react';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TSelectedAddress } from './types';

import style from '../../AddressPostCodeFields.scss';

export const SelectedAddress: React.FC<TSelectedAddress> = ({ addressArray, address, children, className }) => {
    const userAddress = useMemo(() => {
        if (addressArray) {
            return addressArray;
        }

        if (!address) {
            return [];
        }

        return [
            `${address.house || ''} ${address.street || ''}`.trim(),
            address.state,
            address.city,
            address.zip
        ].filter(Boolean);
    }, [address, addressArray]);

    return (
        <div className={clsx(style.addressData, className)}>
            {userAddress.map((item, index, array) => (
                <span
                    key={index}
                    className={clsx(style.addressItem, { [style.isFirstItem]: !index })}
                >
                    {item}{array.length - 1 !== index ? ',' : ''}
                </span>
            ))}

            {children}
        </div>
    );
};
